var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "margin-bottom-10" }, [
      _c("h3", { staticClass: "entity__headline" }, [
        _vm._v("\n            Suchtyp\n        "),
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedSearchType,
                expression: "selectedSearchType",
              },
            ],
            attrs: { id: "kobraSearchtype", name: "kobraSearchType" },
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.selectedSearchType = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _c("option", { attrs: { value: "sworte", selected: "" } }, [
              _vm._v("\n                    Schlagwort\n                "),
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "id_brkey" } }, [
              _vm._v(
                "\n                    Branchengruppenschlüssel\n                "
              ),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "margin-bottom-10" }, [
      _c("h3", { staticClass: "entity__headline" }, [
        _vm._v("\n            Branchengruppe\n        "),
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedBranchGroup,
                expression: "selectedBranchGroup",
              },
            ],
            attrs: { id: "kobraBranchgroups", name: "kobraBranchgroups" },
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.selectedBranchGroup = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          _vm._l(_vm.branchgroups, function (item, index) {
            return _c(
              "option",
              { key: index, domProps: { value: item.id_brgrp } },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(item.titel) +
                    "\n                "
                ),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "margin-bottom-10" },
      [
        _c("h3", { staticClass: "entity__headline" }, [
          _vm._v("\n            Informationstyp\n        "),
        ]),
        _vm._v(" "),
        _vm._l(_vm.infotypes, function (item, index) {
          return _c("div", { key: index }, [
            _c("label", { staticClass: "entity__label" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedInfoType,
                    expression: "selectedInfoType",
                  },
                ],
                staticClass: "entity__checkbox",
                attrs: {
                  id: `kobraInfotype_${index}`,
                  type: "radio",
                  name: "kobraInfotype",
                },
                domProps: {
                  value: item.id_typ,
                  checked: _vm._q(_vm.selectedInfoType, item.id_typ),
                },
                on: {
                  change: function ($event) {
                    _vm.selectedInfoType = item.id_typ
                  },
                },
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "margin-right-5 vertical-middle",
                attrs: { src: item.url_icon },
              }),
              _vm._v(
                "\n                " + _vm._s(item.titel) + "\n            "
              ),
            ]),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }